import React, { useState } from 'react';
import { BrowserRouter as Router, Route } from 'react-router-dom';

import 'semantic-ui-css/semantic.min.css';

import { AuthProvider } from '../context/auth';
import Header from '../components/Header'
import Menu2 from '../components/Menu';
import Slide from 'react-reveal/Slide';



function PaginaPrincipal() {
  const [visible, setVisible] = useState('hidden')
  const continuar = () => {

    if (visible === 'hidden') {
      setVisible('visible')
    } else {
      setVisible('hidden')
    }

  }

  return (


    <AuthProvider>
      {visible === 'visible' ?
        <Slide top>
          <div className='container-fluid col-md-12 mx-auto fixed-top contenedor header' >
            <Header />
          </div>
        </Slide>
        : ''
      }
      <div className="col-md-12">
        <div className='col-md-12 contenedor-principal container-fluid p-0' id='contenedorTotal' >
          {/*  <img className='img-fluid' src='imagenes/compu1.jpg' /> */}
          <div className='hover-principal mx-auto row '></div>
          <Slide top>
            <div className='contenedor-principal-content  row contenedor-fluid'>

              {visible !== 'visible' ?
                <h3 className='text-center py-0 my-0'>Bienvenido a</h3>
                : ''}
              <img className='img-fluid logosygre2 mx-auto py-0 my-0' src='imagenes/sygreca2.png' />

              {visible !== 'visible' ?
                <h3 className='text-center py-0'>Sistemas y Gerencia de Recursos</h3>
                : ''}

              {visible === 'visible' ?
                <a href='#contenido' className='text-center'><i class="fa-solid fa-circle-arrow-down icono-principal"></i></a> : ''}
              <Slide bottom>

                {visible !== 'visible' ?
                  <a type='button' onClick={continuar} className='btn-principal text-center'>Empezar</a>
                  : ''}
              </Slide>
            </div>
          </Slide>

        </div>
      </div>
      {visible === 'visible' ?
        <Slide bottom>
          <div className='col-md-12 mx-auto' id='contenido'>
            <Menu2 />

          </div>
        </Slide>
        : ''}

      <div class="social">
        <ul>
          <li><a href="http://www.facebook.com/falconmasters" target="_blank" class="icon-facebook"><i class="fa-brands fa-facebook"></i></a></li>
          <li><a href="http://www.twitter.com/falconmasters" target="_blank" class="icon-twitter"><i class="fa-brands fa-twitter"></i></a></li>
          <li><a href="http://www.pinterest.com/falconmasters" target="_blank" class="icon-pinterest"><i class="fa-brands fa-youtube"></i></a></li>
          <li><a href="mailto:contacto@falconmasters.com" class="icon-mail"><i class="fa-solid fa-envelope"></i></a></li>
        </ul>
      </div>


    </AuthProvider>
  );
}

export default PaginaPrincipal;



// WEBPACK FOOTER //
// ./src/components/paginaPrincipal.js